export const DEFAULT_QUOTA_ADJUSTMENT = {
  discount: 1,
};

export function normalizeDiscount(value) {
  const discount = Number(value);

  if (!Number.isFinite(discount) || discount <= 0) {
    return DEFAULT_QUOTA_ADJUSTMENT.discount;
  }

  if (discount > 1) {
    return discount / 10;
  }

  return discount;
}

export function getTokenQuotaAdjustment(config, token) {
  if (!config || !token) {
    return DEFAULT_QUOTA_ADJUSTMENT;
  }

  const tokenConfig = config.tokens?.[token];
  if (!tokenConfig) {
    return DEFAULT_QUOTA_ADJUSTMENT;
  }

  return {
    discount: normalizeDiscount(tokenConfig.discount),
  };
}

export function restoreOriginalQuota(quota, adjustment = DEFAULT_QUOTA_ADJUSTMENT) {
  const discount = normalizeDiscount(adjustment.discount);
  return quota / discount;
}
